import React from "react";
import { Stack } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import "./ConfirmUpgradeDrawer.scss";
import BottomDrawer from "../../BottomDrawer/BottomDrawer";
import { GenericModalProps } from "../../../utils/constants/generic-types";
import PrimaryActionButton from "../../Buttons/PrimaryActionButton/PrimaryActionButton";
import { usePaywallPricing } from "../../../hooks/usePaywallPricing";
import { showErrorToastDanger } from "../../../utils/show-toast";
import GemIcon from "../../icons/GemIcon";

interface ConfirmUpgradeDrawerProps extends GenericModalProps {
  discountAmount: string;
}

export default function ConfirmUpgradeDrawer({
  isOpen,
  onClose,
  discountAmount,
}: ConfirmUpgradeDrawerProps) {
  const { yearlyPackage, purchase, isPurchasing } = usePaywallPricing();
  const { t } = useTranslation("common");

  const switchToYearlySub = () => {
    if (!yearlyPackage) {
      showErrorToastDanger("profile.no_subscription_package_found");
      return;
    }
    purchase(yearlyPackage, onClose);
  };

  return (
    <BottomDrawer
      isOpen={isOpen}
      onClose={onClose}
      containerClass="confirm-downgrade-drawer"
    >
      <Stack className="drawer-content">
        <Stack gap={2} className="align-items-center">
          <span className="crown-icon-container">
            <GemIcon width={48.5} height={48.5} />
          </span>
          <Stack className="text-content">
            <h2 className="main-copy">{t("profile.save_with_yearly")}</h2>
            <p className="sub-copy">
              {t("profile.save_amount_when_you_switch_to_yearly_subscription", {
                amount: discountAmount,
              })}
              {t("punctuations.full_stop")}
            </p>
          </Stack>
        </Stack>

        <PrimaryActionButton
          text={t("profile.switch_to_yearly")}
          onClick={switchToYearlySub}
          disabled={isPurchasing}
        />
      </Stack>
    </BottomDrawer>
  );
}
